<template>
  <div>
      <div class="back" @click="$router.go(-1)"></div>
    <div class="wrapper">

      <h1>Register Hub</h1>
      <div class="input">
        <p>Device ID</p>
        <div class="input-container">
      <input type="text" placeholder="device ID" v-model="id" />
      </div>
      </div>
     <div class="input">
        <p>Device Name</p>
        <div class="input-container">
      <input type="text" placeholder="Device Name" v-model="name" />
      </div>
      </div>
     <div class="input">
        <p>Device Type</p>
        <div class="input-container">
      <input type="text" placeholder="Device Type" v-model="type" />
      </div>
      </div>
     <div class="input">
        <p>Device Location (optional)</p>
        <div class="input-container">
      <input type="text" placeholder="Device Location" v-model="location" />
      </div>
      </div>
   <div class="input">
        <p>Device Pin</p>
        <div class="input-container">
      <input type="text" placeholder="Pin" v-model="pin"  maxlength=6 />
      </div>
      </div>
    <button>Add Device</button>
    </div>

  </div>
</template>

<script>
import awsInfo from '../../public/websocket';

export default {
  data() {
    return {
      id: '',
      name: '',
      type: '',
      location: '',
      pin: '',
    };
  },
  methods: {
    addDevice() {
      awsInfo.addDevice(this.id, this.name, this.type, this.location);
    },
  },

};
</script>

<style scoped>

button {
  margin-top: 50px;
  width: 148px;
  height: 63px;
  background-color: var(--success);
  border-radius: var(--border-radius);
  font-weight: 500;
  font-size: 20px;
}

h1 {
  margin-top: 28px;
    font-weight: 500;
    font-size: 24px;
}
.wrapper {
  margin-top: 0px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

</style>
